export default function LogoHeader() {
  return (
    <div className="xl:justify-self-start cursor-pointer">
      <a href="/ui/dashboard">
        <img src={process.env.PUBLIC_URL + "/logo-new.svg"} alt="Logo" className="h-12" /> </a>
    </div>
  );
}
